const container = {
  minHeight: '100vh',
}

const content = {
  marginTop: 'calc(3.5rem + 3rem)',
}

export default {
  container,
  content,
}
